import React from 'react';
import { Box, Typography } from '@mui/material';
import PaymentHistory from './PaymentHistory';

const PaymentHistorySection = ({ paymentHistory, loading }) => {
  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ 
          fontWeight: 700, 
          color: '#1a202c',
          mb: 1
        }}>
          Payment History
        </Typography>
        <Typography variant="body1" sx={{ 
          color: '#718096',
          fontSize: '1.1rem'
        }}>
          View your payment history and transaction details
        </Typography>
      </Box>
      
      <PaymentHistory paymentHistory={paymentHistory} loading={loading} />
    </Box>
  );
};

export default PaymentHistorySection;
